<form [formGroup]="formGroup">
  <mat-accordion multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.authorization-card.attachments.header' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          <ng-container *ngIf="!attachmentsLoading; else attachmentsLoadingEl">
            {{ 'patient-details.authorization-card.attachments.description' | translate: { count: attachments?.length || 0 } }}
          </ng-container>
          <ng-template #attachmentsLoadingEl>
            {{ 'patient-details.authorization-card.attachments.loading' | translate }}
          </ng-template>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mmx-auth-attachments
        [authorizationId]="formGroup.get('id').value"
        [attachmentsLoading]="attachmentsLoading"
        [attachments]="attachments"
        (newAttachmentsAdded)="newAttachmentsAdded.emit()"
        (pendingAttachments)="pendingAttachments.emit($event)"
      ></mmx-auth-attachments>
    </mat-expansion-panel>

    <mat-expansion-panel *ngFor="let portal of availablePortals; let i = index" [expanded]="i === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'patient-details.authorization-card.attachments.questions-header' | translate: { portal: portal.name } }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column">
        <mat-divider class="mb-5"></mat-divider>

        <mmx-auth-portal-questions-form
          [authorizationId]="formGroup.get('id').value"
          [questions]="questions"
          [portal]="portal"
          formControlName="questions"
        ></mmx-auth-portal-questions-form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</form>
